// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__YinI7","footerButtonGroup":"footer_footerButtonGroup__beS_R","footerButton":"footer_footerButton__db0aa","tooltip":"footer_tooltip__0jJ_n"};